export default "__VITE_ASSET__DFl1kohW__"